import { connect } from "react-redux";
import get from "lodash/get";

import {
  getControlPoints as onGetControlPoints,
  createControlPoint as onCreateControlPoint,
  deleteControlPoint as onDeleteControlPoint,
  selectControlPoint as onSelectControlPoint,
  unselectControlPoint as onUnselectControlPoint,
} from "./../../actions/controlPointActions";

const mapStateToProps = (state) => ({
  controlPointsDataState: state.controlPoints.controlPointsDataState,
  createControlPointDataState: state.controlPoints.createControlPointDataState,
  deleteControlPointDataState: state.controlPoints.deleteControlPointDataState,
  controlPoints: get(state, ["controlPoints", "controlPoints"], []),
  selectedControlPointId: get(state, ["controlPoints", "selectedControlPointId"], null),
});

const mapDispatchToProps = { onGetControlPoints, onCreateControlPoint, onDeleteControlPoint, onSelectControlPoint, onUnselectControlPoint };

const withControlPoints = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withControlPoints };
